import axios from 'axios';

import actions from '../constants';

export const fetchBenefits = function() {
  return function(dispatch) {
    return axios.get('/welcome_pages')
    .then(function(response){
      dispatch({ type: actions.FETCH_BENEFITS, benefits: response.data });
    }).catch(function(response){
      console.log('Error getting benefits data');
    });
  };
}



// WEBPACK FOOTER //
// ./src/advocate/onboarding/actions/benefits.js